import {Component, OnInit} from '@angular/core';
import {PlatformsService} from '../../../../core/services/platforms.service';
import {fuseAnimations} from '../../../../core/animations';

@Component({
    selector: 'platforms',
    templateUrl: './platforms.component.html',
    styleUrls: ['./platforms.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class PlatformsComponent implements OnInit {
  platforms = [];
  displayedColumns = [ 'title', 'description', 'infoUrl', 'platformUrl', 'status', 'edit' ];
  constructor(public platformsService: PlatformsService) {
  }

  ngOnInit() {
    this.getPlatforms();
  }

  getPlatforms() {
    this.platformsService.getAllPlatforms().subscribe((res: any) => {
      this.platforms = res;
    });
  }
}
